var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export var Components = {};
export var ComponentInstances = {};
export { Component };
var TemplateCache = {};
var Component = /** @class */ (function () {
    /**
     *
     */
    function Component(componentName, html, options) {
        this.componentName = componentName;
        this.childComponents = {};
        this.childComponentOptions = {};
        this.options = options;
        var staticReference = this.constructor;
        if (!staticReference.template) {
            var temp = document.createElement('div');
            temp.innerHTML = html;
            if (temp.children.item(temp.children.length - 1).tagName === "SCRIPT") {
                document.head.appendChild(temp.children.item(temp.children.length - 1));
            }
            staticReference.isTheContainerAdditional = temp.children.length > 1;
            staticReference.template = componentName ? (staticReference.isTheContainerAdditional ? temp : temp.children.item(0)) : temp;
        }
        //this.container = componentName ? (this.isTheContainerAdditional ? temp : temp.children.item(0)) as HTMLElement : temp
        //this.isTheContainerAdditional? temp : temp.children.item(0) as HTMLElement
        //register component if component name has been set
        if (componentName && !Components[componentName])
            Components[componentName] = this;
    }
    Component.prototype.initComponent = function (options) {
        var c = this.createNewInstance(options);
        c.init();
        c.initAllChildComponents();
        return c;
    };
    Component.prototype.initAllChildComponents = function () {
        var components = this.container.querySelectorAll("div[data-component]");
        for (var i = 0; i < components.length; i++) {
            var component = components.item(i).getAttribute("data-component");
            var componentName = component;
            var componentOptions = {};
            var idx = component.indexOf(',');
            if (idx > 0) {
                componentName = component.substring(0, idx);
                componentOptions = JSON.parse(component.substring(idx + 1));
            }
            var id = components.item(i).id;
            var key = id || componentName;
            var c = Components[componentName];
            c = c.initComponent(componentOptions); //this.getComponentOption(key)
            c.renderTo(components.item(i), true);
            this.childComponents[key] = c;
        }
    };
    Component.prototype.updateAllChildComponents = function () {
        return __awaiter(this, void 0, void 0, function () {
            var components, _a, _b, _i, key, component;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        components = this.childComponents;
                        _a = [];
                        for (_b in components)
                            _a.push(_b);
                        _i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        key = _a[_i];
                        component = components[key];
                        return [4 /*yield*/, component.update(this.getComponentOption(key))];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * init
     */
    Component.prototype.init = function () {
    };
    Component.prototype.update = function (options) {
        return Promise.resolve();
    };
    Component.prototype.onInitComplete = function () { };
    Component.prototype.onPause = function () { };
    Component.prototype.onResume = function () { };
    Component.prototype.getComponent = function (componentName) {
        return this.childComponents[componentName];
    };
    Component.prototype.getComponentOption = function (componentName) {
        return this[componentName + "ComponentOptions"]; // this.childComponentOptions[componentName]
    };
    Component.prototype.createNewInstance = function (options) {
        options = Object.assign(options || {}, this.options);
        var staticReference = this.constructor;
        var clonedTemplate = staticReference.template.cloneNode(true);
        var component = new staticReference(this.componentName, undefined);
        component.options = options;
        component.container = clonedTemplate;
        if (options["id"])
            ComponentInstances[options["id"]] = component;
        return component;
    };
    Component.prototype.renderTo = function (placeholder, replace) {
        if (replace === void 0) { replace = false; }
        // let staticReference = (<typeof Component>this.constructor);
        // let isTheContainerAdditional = staticReference.isTheContainerAdditional
        // let temp = isTheContainerAdditional ? this.container : this.container.children.item(0)
        if (replace) {
            placeholder.parentNode.replaceChild(this.container, placeholder);
        }
        else
            placeholder.appendChild(this.container);
    };
    /**
     * If the template has multiple root elements,
     * We have to add an additional container.
     */
    Component.isTheContainerAdditional = false;
    return Component;
}());
export default Component;
